import { useEffect } from 'react';
import { useAppStore } from '../state/store';

export function Toast() {
  const hint = useAppStore((s) => s.hint);
  const setHint = useAppStore((s) => s.setHint);

  useEffect(() => {
    if (!hint) return;
    const t = setTimeout(() => setHint(null), 5000);
    return () => clearTimeout(t);
  }, [hint, setHint]);

  if (!hint) return null;
  return (
    <div className="toast material" role="status" onClick={() => setHint(null)}>
      {hint}
    </div>
  );
}
